import $ from "jquery";
import {getCookie} from "./gppy-misc";

let i18 = {
    "pl": {
        "This name has already been taken": "Ta nazwa jest już zajęta"
    }
}

function t(message) {
    if (lang === "en") return message;
    if (lang === "pl") return i18['pl'][message] ? i18['pl'][message] : message;
}

let lang = document.documentElement.getAttribute("lang").toLowerCase() === "pl" ? "pl" : "en";

var GPPYRenameUser = {

    init: function() {
        let rel = document.querySelector('.userRename');
        if (rel)
            rel.addEventListener('click', GPPYRenameUser.renameMode);

        let el = document.querySelector(".userRenameElement");
        if (el)
            el.addEventListener("keydown", (e) => {
                if (e.code === "NumpadEnter" || e.code === "Enter") {
                    e.preventDefault();
                    GPPYRenameUser.doRename();
                }
            })

    },

    renameMode: function(e) {
        let elClicked = e.target;
        let el = elClicked.previousElementSibling;
        const selection = window.getSelection();
        const range = document.createRange();
        selection.removeAllRanges();
        range.selectNodeContents(el);
        range.collapse(false);
        selection.addRange(range);
        el.focus();
    },

    doRename() {
        const el = document.querySelector(".userRenameElement");
        let new_name = el.textContent;
        let params = 'new_name='+new_name;
        fetch('/api/renameUser', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json',
              'X-CSRFToken': getCookie('csrftoken')
            },
            body: params
        }).then(res => res.json()).then((res) => {
            if (res.result === "OK")
                document.activeElement.blur();
            else alert(t("This name has already been taken"))
        }).catch(() => {
            alert("Problem with renaming")
        })
    }

}

$('document').ready(GPPYRenameUser.init);


